export default __webpack_public_path__ + "static/media/mywem.ad0a28fe.svg";